import angular from 'angular';
import nodeOsInfoTable from './node-os-info-table.component';

export default angular.module('eshq.nodeOsInfoTable', [])
  .component('eshqNodeOsInfoTable', nodeOsInfoTable)
  .name;



// WEBPACK FOOTER //
// ./ui/src/components/node-os-info-table/node-os-info-table.js